// TeacherItem.js
import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { TeacherForm } from "../TeacherForm";
import { TeacherAPI } from "../../../../api";
import "./TeacherItem.scss";

const teacherController = new TeacherAPI();

export function TeacherItem(props) {
  const { teacher, onReload, accessToken } = props;
  const [showModal, setShowModal] = useState(false);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const [showConfirm, setShowConfirm] = useState(false);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onDelete = async () => {
    try {
      await teacherController.deleteTeacher(accessToken, teacher._id);
      console.log("Docente borrado", teacher._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="teacher-item">
        {/* Imagen del Profesor */}
        <div className="teacher-item__image">
          <Image src={teacher.avatar || "default-avatar.png"} />
        </div>

        {/* Información del Profesor */}
        <div className="teacher-item__content">
          <div className="teacher-item__info-title">
            <h2>
              {teacher.firstname} {teacher.lastname}
            </h2>
          </div>
          <div className="teacher-item__info-path">
            <p>{teacher.email}</p>
          </div>

          {/* Información de classrole */}
          {teacher.classrole && teacher.classrole.length > 0 ? (
            <div className="teacher-item__classrole">
              {teacher.classrole.map((roleItem, index) => (
                <div key={index} className="teacher-item__classrole-item">
                  <p>
                    <strong>{roleItem.classnumber}</strong> - {roleItem.role}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="teacher-item__no-roles">Sin roles asignados</p>
          )}

          {/* Botones de Acción */}
          <div className="teacher-item__buttons">
            <Button icon primary onClick={onOpenCloseModal}>
              <Icon name="pencil" />
            </Button>
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      </div>

      {/* Modal para editar el profesor */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Editar Docente"
        size="small"
      >
        <TeacherForm
          teacher={teacher}
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>

      {/* Confirmación para eliminar el profesor */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Estás seguro de eliminar al docente ${teacher.firstname}?`}
        size="mini"
      />
    </>
  );
}
